import * as z from "zod/v4";

/**
 * Schema for portal optimization state - current state of settings
 * Used by the "Optimize your return flow" section
 */

export const PortalOptimizationStateSchema_ = z.object({
  exchangeAgentEnabled: z
    .boolean()
    .describe("Whether the AI Exchange Agent is enabled at the team level"),
  exchangeBonusesEnabled: z
    .boolean()
    .describe("Whether exchange bonuses are configured in any return flow"),
  aiReturnReasonsEnabled: z
    .boolean()
    .describe("Whether AI Return Reasons step is present in any return flow"),
});

export const PortalOptimizationStateSchema: z.ZodType<PortalOptimizationState> =
  PortalOptimizationStateSchema_;

export interface PortalOptimizationState
  extends z.infer<typeof PortalOptimizationStateSchema_> {}

// Output schema for getPortalOptimizationState
export const GetPortalOptimizationStateOutputSchema = z.object({
  state: PortalOptimizationStateSchema,
});

export type GetPortalOptimizationStateOutput = z.infer<
  typeof GetPortalOptimizationStateOutputSchema
>;

// RPC definition
export const getPortalOptimizationState = {
  name: "getPortalOptimizationState" as const,
  input: z.object({}),
  output: GetPortalOptimizationStateOutputSchema,
};
